export const oswestryEs = {
  promInstructions:
    "Por favor elige la opción que más se acerque a describir cómo tu dolor de espalda afecta tu situación actual.",
  questions: [
    {
      scaleStartLabel: "Sin Dolor",
      scaleEndLabel: "Dolor Extremo",
      scaleLabels: [
        "Puedo tolerar el dolor que tengo sin tener que usar medicación para el dolor",
        "El dolor es malo, pero puedo manejarlo sin tener que tomar medicación para el dolor",
        "La medicación para el dolor me proporciona alivio completo del dolor",
        "La medicación para el dolor me proporciona alivio moderado del dolor",
        "La medicación para el dolor me proporciona poco alivio del dolor",
        "La medicación para el dolor no tiene efecto en mi dolor",
      ],
      text: "¿Puedes describir la intensidad de tu dolor?",
    },
    {
      scaleStartLabel: "No Afectado",
      scaleEndLabel: "Muy Afectado",
      scaleLabels: [
        "Puedo cuidarme normalmente sin causar dolor aumentado",
        "Puedo cuidarme normalmente, pero aumenta mi dolor",
        "Es doloroso cuidarme, y soy lento y cuidadoso",
        "Necesito ayuda, pero puedo manejar la mayor parte de mi cuidado personal",
        "Necesito ayuda todos los días en la mayoría de aspectos de mi cuidado",
        "No me visto. Me lavo con dificultad y me quedo en cama",
      ],
      text: "¿Puedes describir cómo tus síntomas de espalda afectan tu cuidado personal?",
    },
    {
      scaleStartLabel: "No Afectado",
      scaleEndLabel: "Muy Afectado",
      scaleLabels: [
        "Puedo levantar pesos pesados sin dolor aumentado",
        "Puedo levantar pesos pesados, pero causa dolor aumentado",
        "El dolor me impide levantar pesos pesados del suelo, pero puedo manejar si los pesos están convenientemente posicionados, ej., en una mesa",
        "El dolor me impide levantar pesos pesados, pero puedo manejar pesos ligeros a medianos si están convenientemente posicionados",
        "Solo puedo levantar pesos muy ligeros",
        "No puedo levantar o cargar nada en absoluto",
      ],
      text: "¿Puedes describir cómo tus síntomas de espalda afectan tu capacidad para levantar pesos?",
    },
    {
      scaleStartLabel: "No Afectado",
      scaleEndLabel: "Muy Afectado",
      scaleLabels: [
        "El dolor no me impide caminar cualquier distancia",
        "El dolor me impide caminar más de 1 milla",
        "El dolor me impide caminar más de ½ milla",
        "El dolor me impide caminar más de ¼ milla",
        "Solo puedo caminar con muletas o bastón",
        "Estoy en cama la mayor parte del tiempo y tengo que gatear al baño",
      ],
      text: "¿Puedes describir cómo tus síntomas de espalda afectan tu capacidad para caminar?",
    },
    {
      scaleStartLabel: "No Afectado",
      scaleEndLabel: "Muy Afectado",
      scaleLabels: [
        "Puedo sentarme en cualquier silla todo el tiempo que quiera",
        "Solo puedo sentarme en mi silla favorita todo el tiempo que quiera",
        "El dolor me impide sentarme por más de 1 hora",
        "El dolor me impide sentarme por más de ½ hora",
        "El dolor me impide sentarme por más de 10 minutos",
        "El dolor me impide sentarme en absoluto",
      ],
      text: "¿Puedes describir cómo tus síntomas de espalda afectan tu capacidad para sentarte?",
    },
    {
      scaleStartLabel: "No Afectado",
      scaleEndLabel: "Muy Afectado",
      scaleLabels: [
        "Puedo permanecer de pie todo el tiempo que quiera sin dolor aumentado",
        "Puedo permanecer de pie todo el tiempo que quiera, pero aumenta mi dolor",
        "El dolor me impide permanecer de pie por más de 1 hora",
        "El dolor me impide permanecer de pie por más de ½ hora",
        "El dolor me impide permanecer de pie por más de 10 minutos",
        "El dolor me impide permanecer de pie en absoluto",
      ],
      text: "¿Puedes describir cómo tus síntomas de espalda afectan tu capacidad para permanecer de pie?",
    },
    {
      scaleStartLabel: "No Afectado",
      scaleEndLabel: "Muy Afectado",
      scaleLabels: [
        "El dolor no me impide dormir bien",
        "Solo puedo dormir bien usando medicación para el dolor",
        "Incluso cuando tomo medicación, duermo menos de 6 horas",
        "Incluso cuando tomo medicación, duermo menos de 4 horas",
        "Incluso cuando tomo medicación, duermo menos de 2 horas",
        "El dolor me impide dormir en absoluto",
      ],
      text: "¿Puedes describir cómo tus síntomas de espalda afectan tu capacidad para dormir?",
    },
    {
      scaleStartLabel: "No Afectado",
      scaleEndLabel: "Muy Afectado",
      scaleLabels: [
        "Mi vida social es normal y no aumenta mi dolor",
        "Mi vida social es normal, pero aumenta mi nivel de dolor",
        "El dolor me impide participar en actividades más energéticas (ej., deportes, baile)",
        "El dolor me impide salir muy a menudo",
        "El dolor ha restringido mi vida social a mi hogar",
        "Apenas tengo vida social debido a mi dolor",
      ],
      text: "¿Puedes describir cómo tus síntomas de espalda afectan tu vida social?",
    },
    {
      scaleStartLabel: "No Afectado",
      scaleEndLabel: "Muy Afectado",
      scaleLabels: [
        "Puedo viajar a cualquier lugar sin dolor aumentado",
        "Puedo viajar a cualquier lugar, pero aumenta mi dolor",
        "Mi dolor restringe mi viaje por más de 2 horas",
        "Mi dolor restringe mi viaje por más de 1 hora",
        "Mi dolor restringe mi viaje a viajes cortos necesarios bajo ½ hora",
        "Mi dolor impide todo viaje excepto visitas al médico/terapeuta u hospital",
      ],
      text: "¿Puedes describir cómo tus síntomas de espalda afectan tu capacidad para viajar?",
    },
    {
      scaleStartLabel: "No Afectado",
      scaleEndLabel: "Muy Afectado",
      scaleLabels: [
        "Mis actividades normales de hogar/trabajo no causan dolor",
        "Mis actividades normales de hogar/trabajo aumentan mi dolor, pero aún puedo realizar todo lo que se requiere de mí",
        "Puedo realizar la mayor parte de mis deberes de hogar/trabajo, pero el dolor me impide realizar actividades más físicamente estresantes (ej., levantar, aspirar)",
        "El dolor me impide hacer cualquier cosa excepto deberes ligeros",
        "El dolor me impide hacer incluso deberes ligeros",
        "El dolor me impide realizar cualquier trabajo o tareas domésticas",
      ],
      text: "¿Puedes describir cómo tus síntomas de espalda afectan tu empleo y deberes domésticos?",
    },
  ],
};
